//prod
const ApiHost = "https://co.kig.pl/api";
//dev
//const ApiHost = "http://localhost:5000";

export {ApiHost}